export const ErrorMessages = {
    VIDEO_MSG: 'There was an error playing your video.',
    REFRESH_MSG: 'Please refresh the page and try again.',
    NOT_ACTIVE_MSG: 'This video is not currently active.',
    DOMAIN_MSG: 'This video is not permitted to play on this page.',
};